<template>
    <vx-card class="vs-con-loading__container" id="loading-container">
        <div
            slot="no-body"
            :style="{
                background: `rgba(var(--vs-primary),.7)`,
            }"
        >
            <div class="vx-row no-gutter justify-center p-12">
                <div class="text-center">
                    <h1 class="text-center font-bold text-white">
                        <feather-icon
                            :icon="'SendIcon'"
                            class="p-3 inline-flex rounded-full"
                            :class="[`text-white`, { 'mb-4': true }]"
                            :style="{
                                background: `rgba(var(--vs-primary),.4)`,
                            }"
                        ></feather-icon>
                        Send Voucher
                    </h1>
                </div>
            </div>

            <div v-if="form" class="vx-row no-gutter w-full">
                <div class="vx-col w-full d-theme-dark-bg p-12">
                    <div class="vx-row">
                        <div class="vx-col w-1/2 mb-3">
                            <vs-input
                                type="number"
                                name="discount"
                                label="Discount Percentage"
                                v-model="form.discount"
                                :size="size"
                                class="w-full"
                                :danger="!!errors.discount"
                                :danger-text="
                                    errors.discount?.reduce(
                                        (acc, e) => acc + `${e}\n`,
                                        ''
                                    )
                                "
                                color="primary"
                                :description-text="discountHelpText"
                            />
                        </div>
                    </div>

                    <div v-show="show.single" class="mb-3">
                        <form @keyup.enter="send">
                            <div class="vx-row">
                                <div class="vx-col w-full mb-3">
                                    <vs-input
                                        name="email"
                                        color="primary"
                                        icon-no-border
                                        icon="icon icon-user"
                                        icon-pack="feather"
                                        label="Name"
                                        v-model="form.name"
                                        :size="size"
                                        class="w-full"
                                        :danger="!!errors.name"
                                        :danger-text="
                                            errors.name?.reduce(
                                                (acc, e) => acc + `${e}\n`,
                                                ''
                                            )
                                        "
                                        description-text="Single name without suffix"
                                    />
                                </div>
                                <div class="vx-col w-full mb-3">
                                    <vs-input
                                        name="email"
                                        icon-no-border
                                        color="primary"
                                        icon="icon icon-phone"
                                        icon-pack="feather"
                                        label="Mobile"
                                        v-model="form.phone1"
                                        :size="size"
                                        class="w-full"
                                        :danger="!!errors.phone1"
                                        :danger-text="
                                            errors.phone1?.reduce(
                                                (acc, e) => acc + `${e}\n`,
                                                ''
                                            )
                                        "
                                    />
                                </div>
                                <div class="vx-col w-full mb-3">
                                    <vs-input
                                        name="email"
                                        color="primary"
                                        icon-no-border
                                        icon="icon icon-mail"
                                        icon-pack="feather"
                                        label="Email"
                                        v-model="form.email1"
                                        :size="size"
                                        class="w-full"
                                        :danger="!!errors.email1"
                                        :danger-text="
                                            errors.email1?.reduce(
                                                (acc, e) => acc + `${e}\n`,
                                                ''
                                            )
                                        "
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div v-show="!show.single" class="mb-3">
                        <form>
                            <div class="vx-row">
                                <div class="vx-col w-full mb-3">
                                    <vs-input
                                        color="primary"
                                        icon-no-border
                                        icon="icon icon-user"
                                        icon-pack="feather"
                                        label="Joint Name"
                                        v-model="form.name"
                                        :size="size"
                                        class="w-full"
                                        :danger="!!errors.name"
                                        :danger-text="
                                            errors.name?.reduce(
                                                (acc, e) => acc + `${e}\n`,
                                                ''
                                            )
                                        "
                                        description-text="Joint client name e.g. Sally and David Bloggs"
                                    />
                                </div>
                                <div class="vx-col w-1/2 mb-3">
                                    <vs-input
                                        color="primary"
                                        name="email"
                                        icon-no-border
                                        icon="icon icon-phone"
                                        icon-pack="feather"
                                        label="Mobile 1"
                                        v-model="form.phone1"
                                        :size="size"
                                        class="w-full"
                                        :danger="!!errors.phone1"
                                        :danger-text="
                                            errors.phone1?.reduce(
                                                (acc, e) => acc + `${e}\n`,
                                                ''
                                            )
                                        "
                                    />
                                </div>
                                <div class="vx-col w-1/2 mb-3">
                                    <vs-input
                                        color="primary"
                                        icon-no-border
                                        icon="icon icon-phone"
                                        icon-pack="feather"
                                        label="Mobile 2"
                                        v-model="form.phone2"
                                        :size="size"
                                        class="w-full"
                                        :danger="!!errors.phone2"
                                        :danger-text="
                                            errors.phone2?.reduce(
                                                (acc, e) => acc + `${e}\n`,
                                                ''
                                            )
                                        "
                                    />
                                </div>
                                <div class="vx-col w-1/2 mb-3">
                                    <vs-input
                                        color="primary"
                                        icon-no-border
                                        icon="icon icon-mail"
                                        icon-pack="feather"
                                        label="Email 1"
                                        v-model="form.email1"
                                        :size="size"
                                        class="w-full"
                                        :danger="!!errors.email1"
                                        :danger-text="
                                            errors.email1?.reduce(
                                                (acc, e) => acc + `${e}\n`,
                                                ''
                                            )
                                        "
                                    />
                                </div>
                                <div class="vx-col w-1/2 mb-3">
                                    <vs-input
                                        color="primary"
                                        icon-no-border
                                        icon="icon icon-mail"
                                        icon-pack="feather"
                                        label="Email 2"
                                        v-model="form.email2"
                                        :size="size"
                                        class="w-full"
                                        :danger="!!errors.email2"
                                        :danger-text="
                                            errors.email2?.reduce(
                                                (acc, e) => acc + `${e}\n`,
                                                ''
                                            )
                                        "
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="flex mb-6">
                        <vs-switch
                            color="primary"
                            v-model="show.single"
                            class="mb-3 mr-3"
                        >
                        </vs-switch>
                        <span v-if="show.single">Single</span>
                        <span v-else>Mirror</span>
                    </div>
                    <div class="flex justify-center">
                        <vs-button
                            class="w-full xl:w-auto"
                            :size="size"
                            @click="send"
                            color="primary"
                            >Send
                        </vs-button>
                    </div>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>
import { http } from '@/services'
import { prices } from '@/mixins/prices'

export default {
    name: 'SendSingleCard',
    components: {},
    mixins: [prices],
    computed: {
        isValidated() {
            if (
                this.form.name &&
                this.form.discount &&
                (this.form.email1 ||
                    this.form.phone1 ||
                    this.form.phone2 ||
                    this.form.email2)
            )
                return true
            return false
        },
        discountHelpText() {
            if (this.form.discount) {
                return `${
                    this.form.discount
                }% discount applied. £${this.costSingle(
                    this.form.discount
                )} Single or £${this.jointPrice(this.form.discount)} for mirror`
            }
            return 'The % discount to be given to the client'
        },
        size() {
            return this.$store.getters.windowBreakPoint === 'xs'
                ? 'large'
                : null
        },
    },
    data() {
        return {
            form: null,
            errors: {},
            show: {
                single: true,
            },
        }
    },
    mounted() {
        this.setForm()
    },
    methods: {
        send() {
            // if (!this.isValidated) return
            this.$vs.loading({
                color: 'primary',
                container: '#loading-container',
                scale: 0.45,
            })
            this.clearErrors()
            if (this.$store.getters.accessCode)
                this.form.code = this.$store.getters.accessCode.code


            if (this.show.single) {
                // remove email2 and phone1
                delete this.form.phone2
                delete this.form.email2
            }


            http.post('send_single', this.form)
                .then((response) => {
                    this.$vs.notify({
                        title: 'Success',
                        text: 'Code sent',
                        color: 'success',
                        icon: 'feather',
                        iconPack: 'icon-send',
                        position: 'top-center',
                    })
                    this.$vs.loading.close(
                        '#loading-container > .con-vs-loading'
                    )
                    this.setForm()
                    this.$emit('update')
                })
                .catch((error) => {
                    this.handleErrors(error.response.data)
                    this.$vs.loading.close(
                        '#loading-container > .con-vs-loading'
                    )
                })
        },
        clearErrors() {
            this.errors = {}
        },
        setForm() {
            this.form = {
                name: null,
                discount: 100,
                phone1: null,
                phone2: null,
                email1: null,
                email2: null,
            }
        },
        handleErrors(errors) {
            if ('non_field_errors' in errors) {
                for (let i = 0; i < errors.non_field_errors.length; i++) {
                    this.$vs.notify({
                        title: 'Error',
                        text: errors.non_field_errors[i],
                        color: 'danger',
                        icon: 'feather',
                        iconPack: 'icon-alert-circle',
                        position: 'top-center',
                    })
                }
            }
            this.errors = errors
        },
    },
}
</script>

<style scoped>
.max {
    max-height: 320px;
}
</style>
